import { render, staticRenderFns } from "./activityPage.vue?vue&type=template&id=2894f6a0&scoped=true&"
import script from "./activityPage.vue?vue&type=script&lang=js&"
export * from "./activityPage.vue?vue&type=script&lang=js&"
import style0 from "./activityPage.vue?vue&type=style&index=0&id=2894f6a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2894f6a0",
  null
  
)

export default component.exports